// extracted by mini-css-extract-plugin
export var author = "SimpleBlogLatestSection-module--author--d9e19";
export var backgroundImage = "SimpleBlogLatestSection-module--backgroundImage--1b0de";
export var ctaHolder = "SimpleBlogLatestSection-module--ctaHolder--5283b";
export var date = "SimpleBlogLatestSection-module--date--416ee";
export var excerpt = "SimpleBlogLatestSection-module--excerpt--60fd2";
export var featuredImage = "SimpleBlogLatestSection-module--featuredImage--ffaab";
export var featuredImageRemote = "SimpleBlogLatestSection-module--featuredImageRemote--b9d1a";
export var filters = "SimpleBlogLatestSection-module--filters--6d7ef";
export var heading = "SimpleBlogLatestSection-module--heading--e4621";
export var loadMore = "SimpleBlogLatestSection-module--loadMore--07b4a";
export var loadMoreButton = "SimpleBlogLatestSection-module--loadMoreButton--cc7fb";
export var postItemCode = "SimpleBlogLatestSection-module--postItemCode--93860";
export var postItemConsulting = "SimpleBlogLatestSection-module--postItemConsulting--d57ba";
export var postItemContent = "SimpleBlogLatestSection-module--postItemContent--8b812";
export var postItemEducation = "SimpleBlogLatestSection-module--postItemEducation--02bc3";
export var postItemWrapper = "SimpleBlogLatestSection-module--postItemWrapper--a3d37";
export var postList = "SimpleBlogLatestSection-module--postList--c2fa3";
export var readmoreBtn = "SimpleBlogLatestSection-module--readmoreBtn--d4e67";
export var tag = "SimpleBlogLatestSection-module--tag--1843f";
export var tagList = "SimpleBlogLatestSection-module--tagList--d0938";
export var title = "SimpleBlogLatestSection-module--title--c5570";
export var titleWrapper = "SimpleBlogLatestSection-module--titleWrapper--1a60e";
export var wrapper = "SimpleBlogLatestSection-module--wrapper--96e48";